var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noData"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/car/noCar.png"),"alt":""}}),_c('span',[_vm._v("目前没有添加商品哦～")])])])
}]

export { render, staticRenderFns }